import React from 'react';
import { CardHeader, Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { CardResponsive } from 'src/style/common';
import { format } from 'date-fns';
import { TableRowWrapper } from 'src/pages/FeatureAnalysis/style';
import { tableCells } from 'src/pages/FeatureAnalysis/utils';
import Row from 'src/frontend-common/components/Row';
import { IFileDetails } from 'src/pages/FeatureAnalysis';

const renderCell = (value?: string | number) => {
  const hasValue = value !== undefined && value !== null && (typeof value === 'number' || (typeof value === 'string' && value.trim() !== ''));

  return <TableCell align="left">{hasValue ? value : <Skeleton data-testid="skeleton" width={53} />}</TableCell>;
};

const UploadDetailsTable: React.FC<{
  fileDetails: IFileDetails | undefined;
}> = ({ fileDetails }) => (
  <CardResponsive>
    <CardHeader title="Upload details" />
    <Table>
      <TableHead>
        <TableRow>
          {tableCells.map((header) => (
            <TableCell align="left" key={header}>
              <Row>
                <>{header}</>
              </Row>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody style={{ backgroundColor: 'white' }}>
        <TableRowWrapper>
          {renderCell(fileDetails?.original_file_name)}
          {renderCell(fileDetails?.n_records)}
          {renderCell(fileDetails?.n_errors)}
          {renderCell(fileDetails?.n_matching_ids)}
          {renderCell(fileDetails?.n_missing_ids)}
          {renderCell(fileDetails?.ok_label_details)}
          {renderCell(fileDetails?.ko_label_details)}
          {fileDetails?.created_at ? renderCell(format(new Date(fileDetails.created_at), 'dd LLLL yyyy, HH:mm')) : renderCell(undefined)}
        </TableRowWrapper>
      </TableBody>
    </Table>
  </CardResponsive>
);

export default UploadDetailsTable;
